export const currencySlider = () => {
  let currencySlider = new Swiper(".currency__slider", {
    spaceBetween: 30,
    navigation: {
      nextEl: '.currency__button--next',
      prevEl: '.currency__button--prev',
    },
    breakpoints: {
      320: {
          slidesPerView: 1,
          spaceBetween: 40
      },
      370: {
          slidesPerView: 2,
          spaceBetween: 40
      },
      576: {
          slidesPerView: 3,
      },
      768: {
          slidesPerView: 4
      },
      992: {
          slidesPerView: 5
      },
      1200: {
          slidesPerView: 6
      }
  }
  });
}